
import { supabaseCustomRole } from '@/lib/supabase/customRoleClient';
import { createLatestPricesMap } from '../dealerTransformers';

// Removed fetchDealersData - now using unifiedDealerService

export const fetchQuotationsData = async () => {
  const { data: quotations, error: quotationsError } = await supabaseCustomRole
    .from('dealer_quotations')
    .select('dealer_id, metal, spread_percentage, spread_fixed, spread_type')
    .eq('metal', 'ORO')
    .order('created_at', { ascending: false });
  
  if (quotationsError) {
    console.error("Error fetching quotations:", quotationsError);
    throw quotationsError;
  }
  
  return quotations;
};

export const fetchDealersWithPrices = async () => {
  // Use unified dealer service for consistency
  const { supabaseCustomRole } = await import('@/lib/supabase/customRoleClient');
  
  const { data: dealersData, error: dealersError } = await supabaseCustomRole
    .from('vw_dealers_with_ratings')
    .select('*');
    
  if (dealersError) {
    console.error("Error fetching dealers:", dealersError);
    throw dealersError;
  }
  
  const quotations = await fetchQuotationsData();
  return { dealersData: dealersData || [], latestPrices: createLatestPricesMap(quotations, dealersData || []) };
};
